export default "__VITE_ASSET__t5Y7r9XB__"